export default "__VITE_ASSET__7epDWIRg__"